import React from "react";

type KategoriState = {
    open: boolean;
    id: number | string | undefined;
    nama: string;
};

type PrintBarcodeState = {
    open: boolean;
    sku?: string | null;
    namaBarang: string;
    hargaBarang: string;
};

const initialKategoriState: KategoriState = {
    open: false,
    id: undefined,
    nama: "",
};

const initialPrintBarcodeState: PrintBarcodeState = {
    open: false,
    sku: undefined,
    namaBarang: "",
    hargaBarang: "",
};

export default function useStokBarangModals() {
    const [isModalKategoriOpen, setIsModalKategoriOpen] = React.useState(false);
    const [isModalKatalogOpen, setIsModalKatalogOpen] = React.useState(false);
    const [isModalImportOpen, setIsModalImportOpen] = React.useState(false);
    const [isModalMutasiOpen, setIsModalMutasiOpen] = React.useState(false);
    const [deleteKategoriState, setDeleteKategoriState] =
        React.useState<KategoriState>(initialKategoriState);
    const [editKategoriState, setEditKategoriState] =
        React.useState<KategoriState>(initialKategoriState);
    const [printBarcodeState, setPrintBarcodeState] =
        React.useState<PrintBarcodeState>(initialPrintBarcodeState);

    const handleOpenModalKategori = React.useCallback(() => {
        setIsModalKategoriOpen(true);
    }, []);

    const handleCloseModalKategori = React.useCallback(() => {
        setIsModalKategoriOpen(false);
    }, []);

    const handleOpenModalKatalog = React.useCallback(() => {
        setIsModalKatalogOpen(true);
    }, []);

    const handleCloseModalKatalog = React.useCallback(() => {
        setIsModalKatalogOpen(false);
    }, []);

    const handleOpenModalImport = React.useCallback(() => {
        setIsModalImportOpen(true);
    }, []);

    const handleCloseModalImport = React.useCallback(() => {
        setIsModalImportOpen(false);
    }, []);

    const handleOpenModalMutasi = React.useCallback(() => {
        setIsModalMutasiOpen(true);
    }, []);

    const handleCloseModalMutasi = React.useCallback(() => {
        setIsModalMutasiOpen(false);
    }, []);

    const handleOpenDeleteKategori = React.useCallback(
        (id: number | string, nama: string) => {
            setDeleteKategoriState({
                open: true,
                id,
                nama,
            });
        },
        [],
    );

    const handleCloseDeleteKategori = React.useCallback(() => {
        setDeleteKategoriState(initialKategoriState);
    }, []);

    const handleOpenEditKategori = React.useCallback(
        (id: number, nama: string) => {
            setEditKategoriState({
                open: true,
                id,
                nama,
            });
        },
        [],
    );

    const handleCloseEditKategori = React.useCallback(() => {
        setEditKategoriState(initialKategoriState);
    }, []);

    const handleOpenPrintBarcode = React.useCallback(
        (data: Omit<PrintBarcodeState, "open">) => {
            setPrintBarcodeState({
                open: true,
                ...data,
            });
        },
        [],
    );

    const handleClosePrintBarcode = React.useCallback(() => {
        setPrintBarcodeState(initialPrintBarcodeState);
    }, []);

    return {
        deleteKategoriState,
        editKategoriState,
        handleCloseDeleteKategori,
        handleCloseEditKategori,
        handleCloseModalImport,
        handleCloseModalKatalog,
        handleCloseModalKategori,
        handleCloseModalMutasi,
        handleClosePrintBarcode,
        handleOpenDeleteKategori,
        handleOpenEditKategori,
        handleOpenModalImport,
        handleOpenModalKatalog,
        handleOpenModalKategori,
        handleOpenModalMutasi,
        handleOpenPrintBarcode,
        isModalImportOpen,
        isModalKatalogOpen,
        isModalKategoriOpen,
        isModalMutasiOpen,
        printBarcodeState,
    };
}
